import type { Filters } from '../table/filters/filters';

export interface FilterPreset {
  id: string;
  filter: Filters;
  name: string;
  webEndpoint: string;
}

export type FilterPresetRequestBody = Omit<FilterPreset, 'id'>;

export type FilterPresetResponseBody = FilterPreset;
